import moment from 'moment';

const UNITS = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'] as const;

/**
 * Relative time text such as "10 minutes ago" or "in 2 days".
 * Picks the largest whole unit (truncated), matching the output the app showed before.
 */
export function toRelative(value: moment.MomentInput): string | null {
  const date = moment(value);
  if (!date.isValid()) {
    return null;
  }
  const now = moment();
  const formatter = new (Intl as any).RelativeTimeFormat(moment.locale(), { numeric: 'always' });
  for (const unit of UNITS) {
    const count = Math.trunc(date.diff(now, unit, true));
    if (Math.abs(count) >= 1) {
      return formatter.format(count, unit.slice(0, -1));
    }
  }
  return formatter.format(0, 'second');
}
